var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupandfamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9123 9.7125C21.8248 9.7 21.7373 9.7 21.6498 9.7125C19.7123 9.65 18.1748 8.0625 18.1748 6.1125C18.1748 4.125 19.7873 2.5 21.7873 2.5C23.7748 2.5 25.3998 4.1125 25.3998 6.1125C25.3873 8.0625 23.8498 9.65 21.9123 9.7125Z",
    fill: "#161F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9875 18.375C24.5875 19.3125 22.625 19.6625 20.8125 19.425C21.2875 18.4 21.5375 17.2625 21.55 16.0625C21.55 14.8125 21.275 13.625 20.75 12.5875C22.6 12.3375 24.5625 12.6875 25.975 13.625C27.95 14.925 27.95 17.0625 25.9875 18.375Z",
    fill: "#161F28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05019 9.7125C8.13769 9.7 8.22519 9.7 8.3127 9.7125C10.2502 9.65 11.7877 8.0625 11.7877 6.1125C11.7877 4.1125 10.1752 2.5 8.17519 2.5C6.18769 2.5 4.5752 4.1125 4.5752 6.1125C4.5752 8.0625 6.1127 9.65 8.05019 9.7125Z",
    fill: "#161F28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18789 16.0625C8.18789 17.275 8.45039 18.425 8.92539 19.4625C7.16289 19.65 5.32539 19.275 3.97539 18.3875C2.00039 17.075 2.00039 14.9375 3.97539 13.625C5.31289 12.725 7.20039 12.3625 8.97539 12.5625C8.46289 13.6125 8.18789 14.8 8.18789 16.0625Z",
    fill: "#161F28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 19.8375C15.05 19.825 14.9375 19.825 14.825 19.8375C12.525 19.7625 10.6875 17.875 10.6875 15.55C10.7 13.175 12.6125 11.25 15 11.25C17.375 11.25 19.3 13.175 19.3 15.55C19.2875 17.875 17.4625 19.7625 15.15 19.8375Z",
    fill: "#161F28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0875 22.425C9.2 23.6875 9.2 25.7625 11.0875 27.0125C13.2375 28.45 16.7625 28.45 18.9125 27.0125C20.8 25.75 20.8 23.675 18.9125 22.425C16.775 20.9875 13.25 20.9875 11.0875 22.425Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupandfamily);
export default __webpack_public_path__ + "static/media/groupandfamily.13af13ec6b68bb26b52d798ca11db7d3.svg";
export { ForwardRef as ReactComponent };